import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import classes from "./auth-service-tools612.js";
import { factory } from "./auth-service-tools248.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
const defaultProps = {};
const LevelsGroup = factory((_props, ref) => {
  const props = useProps("LevelsGroup", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    __staticSelector,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "LevelsGroup",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    rootSelector: "levelsGroup"
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
    ref,
    ...getStyles("levelsGroup"),
    ...others
  });
});
LevelsGroup.classes = classes;
LevelsGroup.displayName = "@mantine/dates/LevelsGroup";
export { LevelsGroup };